export const doesTabExist = ({ tabs, selectedTab }) =>
  Object.keys(tabs).indexOf(selectedTab) > -1;
